export const production = process.env.REACT_APP_PRODUCTION === "true";

export const teamsAPI = production
  ? 'https://esgroup-chatbot.herokuapp.com/'
  : 'https://esgroup-chatbot-dev.herokuapp.com/';

